/**
 * Created by Yair on 29/11/2016.
 */
import {api_v2} from 'utils/api-client';
import {initializeApp} from 'firebase/app';
import {getAuth, signInWithCustomToken, browserSessionPersistence, setPersistence} from 'firebase/auth';
import {getDatabase, ref, onValue, off} from 'firebase/database';
import isNull from 'lodash/isNull';

class RealTime {
  constructor() {
    this.auth = {
      token: null,
      userId: null,
      domainUrl: null,
    };
    this.fbdb = null;
    this.hasToken = false;
    this.authenticated = false;
  }

  async init() {
    if (!this.promise) {
      this.promise = new Promise(async (resolve, reject) => {
        const res = await api_v2.get('/websocket/token', {
          responseType: 'json',
        });

        Object.assign(this.auth, res.data);
        this.hasToken = true;

        await this.authWithCustomToken();
        this.authenticated = true;

        resolve();
      });
    }

    return this.promise;
  }

  async authWithCustomToken() {
    try {
      const fbApp = initializeApp({
        databaseURL: this.auth.domainUrl,
        apiKey: this.auth.apiKey,
      });
      const auth = getAuth();
      await setPersistence(auth, browserSessionPersistence);
      const userCredential = await signInWithCustomToken(auth, this.auth.token);
      this.fbdb = getDatabase(fbApp);

      console.log('[OK] Firebase authentication');
    } catch (err) {
      console.log('[FAIL] Firebase authentication', err);
      throw err;
    }
  }

  listenOnAsset(assetId) {
    console.log(`[now] listenOnAsset ${assetId}`);
    return new Promise((resolve, reject) => {
      if (this.fbdb) {
        let timeOut = setTimeout(function() {
          reject({message: 'Timeout occurred'});
        }, 10 * 60 * 1e3); // timeout after 10 minutes

        onValue(ref(this.fbdb, `/users/${this.auth.userId}/assets/${assetId}`), (data) => {
          const value = data.val();
          if (!isNull(value)) {
            timeOut = clearTimeout(timeOut);
            if ('DONE' === value.message) {
              resolve(value);
            } else if ('FAILED' === value.message) {
              reject(value);
            }
          }
        }, (error) => {
          // check for auth error and get token again ...
          reject({
            message: 'Error listenOnAsset',
            error,
          });
        });
      } else {
        reject({message: 'No Firebase token is present'});
      }
    });
  }

  cancelListenOnAsset(assetId) {
    console.log(`[off] listenOnAsset '${assetId}'`);
    if (this.fbdb) {
      off(ref(this.fbdb, `/users/${this.auth.userId}/assets/${assetId}`));
    }
  }
}

const realTime = new RealTime();
export default realTime;
